// src/services/chatReads.js
//
// Chat v2: helper to mark a chat as read for the current user.
// Writes chats/{chatId}/reads/{uid} with `lastReadAt = serverTimestamp`.
//
// Called from ChatRoomV2 on mount and whenever a new message
// arrives while the user has the chat open. Inbox row's "isUnread"
// flag in useChats.js compares chat.lastMessageAt against this
// doc's lastReadAt to decide highlight / dot / badge.

import { doc, setDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '@/firebase/firebase'

export async function markChatRead(chatId, uid, lastMessageId = null) {
  if (!chatId || !uid) return
  try {
    await setDoc(
      doc(db, 'chats', chatId, 'reads', uid),
      {
        uid,
        lastReadAt: serverTimestamp(),
        lastReadMessageId: lastMessageId,
      },
      { merge: true },
    )
  } catch (err) {
    // Non-fatal: worst case the unread badge stays visible until
    // the next mark-read attempt succeeds.
    console.warn('[markChatRead] failed:', err?.code, err?.message)
  }
}
